"use client";

import { IStoryBlokComponent } from "apps/website/components/page/api.types";

import SectionOurPromise from "../../section/SectionOurPromise/SectionOurPromise";

export interface IStoryBlokOurPromise {
  _uid: string;
  component: "section_our_promise";
}

export const StoryBlokOurPromise = ({ blok: _blok }: IStoryBlokComponent<IStoryBlokOurPromise>) => (
  <SectionOurPromise />
);
